module.exports = __webpack_public_path__ + "img/img20.59f56d03.png";